import { useEffect } from "react";
import { connectRealtime, getRealtimeSocket } from "./socket";
import { getToken } from "../auth/auth";
import { RealtimeEvents } from "./events";

export function useRealtime(enabled = true): void {
  useEffect(() => {
    if (!enabled) return;
    if (!getToken()) return;

    const socket = connectRealtime();
    const syncNotifications = () => {
      socket.emit(RealtimeEvents.NotificationsSync, {});
    };
    const onConnectError = () => {
      // keep silent; REST fallback still works
    };
    socket.on("connect", syncNotifications);
    socket.on("connect_error", onConnectError);
    if (socket.connected) {
      syncNotifications();
    }

    return () => {
      socket.off("connect", syncNotifications);
      socket.off("connect_error", onConnectError);
    };
  }, [enabled]);
}

export function useRealtimeSocket() {
  return getRealtimeSocket();
}
